import { BaseHolding } from '@ddt-web/domain';

export class SecurityIdentifierUtil {
	private static readonly ASSET_TYPES_TO_USE_ALADDIN_ID = ['Cash', 'Index', 'ASSET_TYPE_CASH', 'ASSET_TYPE_INDEX'];
	private static readonly MODEL_IDENTIFIER_TYPES = ['MODEL_ID', 'THIRD_PARTY_ID'];

	public static buildSecurityAggregateKey(position: BaseHolding): string {
		if (SecurityIdentifierUtil.MODEL_IDENTIFIER_TYPES.includes(position?.identifierType)) {
			return position?.identifier;
		}

		const hasAladdinId = !!(position?.aladdinId || position?.['identifiers']?.aladdinId || position?.assetId || position?.['identifiers']?.assetId);

		if (SecurityIdentifierUtil.ASSET_TYPES_TO_USE_ALADDIN_ID.includes(position.assetType) && !hasAladdinId) {
			return position.cusip;
		}

		return [
			position?.morningstarSecId || position?.['identifiers']?.morningstarSecId,
			position?.globalId || position?.['identifiers']?.globalId || SecurityIdentifierUtil.translateIdentifier(position, 'GLOBAL_ID'),
			position?.aladdinId || position?.['identifiers']?.aladdinId || SecurityIdentifierUtil.translateIdentifier(position, 'BCUSIP')
			|| position?.assetId || position?.['identifiers']?.assetId, // PAS security does not have aladdinId, just assetId,
			position?.cusip || position?.['identifiers']?.cusip || SecurityIdentifierUtil.translateIdentifier(position, 'CUSIP')
		].filter(identifier => Boolean(identifier)).join('|');
	}

	public static translateIdentifier(position: BaseHolding, identifierType: string): string {
		if (position.identifierType === identifierType && position.identifier) {
			return position.identifier;
		}

		return null;
	}
}
